import React from 'react';
import propTypes from 'prop-types';
import './index.css';

NoSearchResult.propTypes = {
  text: propTypes.string.isRequired
};

NoSearchResult.defaultProps = {
  text: '没有搜索到您想要去的旅行地'
};
export default function NoSearchResult(props) {
  let { text } = props;
  return (
    <div className="no-result">
      <div className="no-result-image">
        <img alt="没有搜索结果" src={require('../../images/no-list.png')} />
      </div>
      <p>{text}</p>
    </div>
  );

}




// WEBPACK FOOTER //
// ./src/components/NoSearchResult/index.js